import React from 'react';
import {VideoSlideComponent} from "../../../components/video-slides/components/video-slide/video-slide.component";
import {ISlideRenderer} from "../video-slides.service.interface";

export class VideoSlideRenderer implements ISlideRenderer {
    constructor(private readonly url: string) {

    }

    get uniqueKey(): string {
        return this.url;
    }

    render(): React.ReactElement {
        return (<VideoSlideComponent url={this.url} />);
    }
}
